import React from "react";
import { Modal, Button } from "react-bootstrap";

interface LogoutProps {
    show: boolean;                 // whether modal is visible
    onConfirm: () => void;         // callback when "Logout" is clicked
    onCancel: () => void;          // callback when "Cancel" is clicked
}

const Logout: React.FC<LogoutProps> = ({ show, onConfirm, onCancel }) => {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Logout</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to log out?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    CANCEL
                </Button>
                <Button id="logout" variant="danger" onClick={onConfirm}>
                    Logout
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default Logout;
